import React, { Fragment } from "react";
import { MENUITEMS } from "./menu";
import { Link } from "react-router-dom";

import classNames from "classnames";
import useResize from "~/hooks/useResize";
import Slider from "~/components/slider";


const Sidebar = ({breakpoint})=> {

  const currentUrl = window.location.pathname;
  const [ width ]  = useResize();

  return (
    <Fragment>
      <div className={ classNames("sidebar-wrapper", {close_icon: width <= breakpoint}) }>

        <nav className="sidebar-main">

          <div id="sidebar-menu">
            <Slider>
              <ul className="sidebar-links custom-scrollbar">
                <li className="back-btn">
                  <div className="mobile-back text-right">
                    <span>Back</span>
                    <i className="fa fa-angle-right pl-2" aria-hidden="true"></i>
                  </div>
                </li>

                { MENUITEMS.map((Item, i)=> (
                  <Fragment key={i}>
                    {Item.Items.map((menuItem, i)=> (
                      <li className="sidebar-list" key={i}>
                        <Link to={menuItem.path} draggable={false} className={`sidebar-link sidebar-title link-nav  ${ menuItem.path === currentUrl ? "active" : "" }`} >
                          <menuItem.icon />
                          <span> {menuItem.title} </span>
                          {menuItem.badge && <label className={menuItem.badge}> {menuItem.badgetxt} </label> }
                        </Link>
                      </li>
                    ))}
                  </Fragment>
                )) }

              </ul>
            </Slider>
          </div>

        </nav>
      </div>
    </Fragment>
  );
};

export default Sidebar;
